import { useState, useEffect, useRef, useMemo } from 'react';
import { Search, Server, AlertTriangle, Info, Wifi, RefreshCw, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, ChevronDown, ChevronUp, TableOfContents, Trash2, CalendarDays, Calendar, Columns3, CirclePlus, Download, DownloadCloud, Check, Copy, X, Bot, Trash, CircleEllipsis, Key, Loader2, User, ArrowBigUp, Terminal, ScanSearch } from 'lucide-react';

import { Modal } from "@mui/material";
// import { jwt_decode } from '../utlis/jwt_decode';
import { useNavigate } from 'react-router-dom';
import ScrollContainer from 'react-indiana-drag-scroll';
import { createPortal } from "react-dom";
import SubnetModal from './AgentSubnet/SubnetModal';

import { showError, showSuccess, showInfo } from '../../utils/toast';
import baseapi from '../../services/baseapi';
import { CustomDropdown } from '../../components/CustomDropdown ';
import { ItemsPerPageDropdown } from '../../components/ItemsPerPageDropdown ';
import RescanModal from './AgentRescanModal';
import { useClientLevel } from '../../hooks/useClientLevel';
import { hasPermission } from '../../utils/permissionsHelper';
import SingleSelectApiDropdown from '../../components/SingleSelectApiDropdown';
import AgentExportModal from './AgentExportModal';


// interface SubnetModalProps {
//     agent?: any
//     open: boolean;
//     onClose: () => void;
// }

// interface SubnetData {
//     name: string;
//     subnet: string;
//     description: string;
//     enabled: boolean;
//     priority: number;
//     excludeIPs: string[];
//     ports: number[];
// }

type ColumnKey =
    | 'hostname'
    | 'ip_address'
    | 'mac_address'
    | 'status'
    | 'version'
    | 'platform'
    | 'architecture'
    | 'tags'
    | 'registered_at'
    | 'last_seen'
    | 'agent_type'
    | 'client_name'
    | 'actions';


interface CopyButtonProps {
    onClick: () => void;
    copied: boolean;
    children: React.ReactNode;
}







// const NameDisplay: React.FC<{ name: string; maxLength?: number }> = ({
//     name,
//     maxLength = 20
// }) => {
//     const [isExpanded, setIsExpanded] = useState(false);

//     const shouldTruncate = name.length > maxLength;
//     const displayName = shouldTruncate && !isExpanded
//         ? `${name.substring(0, maxLength)}...`
//         : name;

//     return (
//         <div className="flex items-center gap-2">
//             <span className="text-white font-medium">
//                 {displayName}
//             </span>
//             {shouldTruncate && (
//                 <button
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setIsExpanded(!isExpanded);
//                     }}
//                     className="text-blue-400 hover:text-blue-300 text-sm underline"
//                 >
//                     {isExpanded ? <><CircleMinus className='w-5 h-5 text-gray-100' /> </> : <><CirclePlus className='w-5 h-5 text-gray-100' /> </>}
//                 </button>
//             )}
//         </div>
//     );
// };





const CopyButton: React.FC<CopyButtonProps> = ({ onClick, copied, children }) => (
    <button
        onClick={onClick}
        className="text-blue-400 hover:text-blue-300 text-xs flex items-center gap-1 transition-all duration-200"
    >
        <div className="relative w-3 h-3">
            <Copy
                className={`w-3 h-3 absolute transition-all duration-300 ${copied ? 'opacity-0 scale-75' : 'opacity-100 scale-100'
                    }`}
            />
            <Check
                className={`w-3 h-3 absolute transition-all duration-300 text-green-400 ${copied ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                    }`}
            />
        </div>
        {children}
    </button>
);

const AGENT_DOWNLOAD_URLS: Record<'windows' | 'linux' | 'darwin' | 'arm', { url: string; filename: string; label: string }> = {
    windows: {
        url: 'https://runners.ovulscanner.com/agents/ovulscanner.exe',
        filename: 'ovulscanner.exe',
        label: 'Windows',
    },
    linux: {
        url: 'https://runners.ovulscanner.com/agents/ovulscanner_linux',
        filename: 'ovulscanner_linux',
        label: 'Linux',
    },
    darwin: {
        url: 'https://runners.ovulscanner.com/agents/ovulscanner_darwin',
        filename: 'ovulscanner_darwin',
        label: 'Mac',
    },
    arm: {
        url: 'https://runners.ovulscanner.com/agents/arm/ovulscanner_linux',
        filename: 'ovulscanner_linux',
        label: 'ARM',
    },
};

const AgentsTable = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [selectedOS, setSelectedOS] = useState<'windows' | 'linux' | 'darwin' | 'arm'>('windows');
    const [showColumnSettings, setShowColumnSettings] = useState(false);
    const [agentData, setAgentData] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [downloadingAgent, setDownloadingAgent] = useState(false);
    // const decodedToken = jwt_decode();
    const [copiedStates, setCopiedStates] = useState<{
        install: boolean;
        reinstall: boolean;
        uninstall: boolean;
        download: boolean;
    }>({
        install: false,
        reinstall: false,
        uninstall: false,
        download: false
    });
    const storedLevel = localStorage.getItem('level');
    const level = storedLevel ? JSON.parse(storedLevel) : null;
    // const clientId = level.client_id;
    // const organizationId = decodedToken.organization_id;
    // const [deleteAgent, setDeleteAgent] = useState<any>({})
    // const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    const [showInstallModal, setShowInstallModal] = useState(false);
    //pagination states and vars
    const [totalItems, setTotalItems] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(30);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const agent_type_vals = [
        { label: 'All', value: 'all' },
        { label: 'End Point agent', value: 'lightweight' },
        { label: 'Probe', value: 'probe' }
    ];
    const [agentType, setAgentType] = useState<any>('all');
    const install_agentType_vals = [
        { label: 'End Point agent', value: 'lightweight' },
        { label: 'Master', value: 'master' }
    ];
    const [install_agentType, setIntsallAgentType] = useState<any>("lightweight")

    const [installCommand, setInstallCommand] = useState<string>("");
    const [loadingCommand, setLoadingCommand] = useState<boolean>(false);
    const [selectedProbeAgent, setSelectedProbeAgent] = useState<any>(null);
    const [customPort, setCustomPort] = useState<string>("");

    const [showRescanModal, setShowRescanModal] = useState(false);
    const [modalJobTypes, setModalJobTypes] = useState<{ value: string; label: string; }[] | undefined>(undefined);
    const [selectedAgent, setSelectedAgent] = useState<any>(null);

    const [unistallModalOpen, setUnistallModalOpen] = useState(false)
    const [uninstallAgent, setUninstallAgent] = useState<any>({})

    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const menuDropdownRef = useRef<HTMLDivElement | null>(null);
    const [showExportModal, setShowExportModal] = useState(false);
    const canCreate = hasPermission('agents', 'create')
    const canDelete = hasPermission('agents', 'delete')
    const canEdit = hasPermission('agents', 'update')

    const fetchMasterCommand = async () => {
        setLoadingCommand(true);
        try {
            const response = await baseapi.get('/agents/install/master', {
                params: {
                    client_id: level.id,
                    api_url: window.location.origin,
                    domain: window.location.origin,
                    platform: selectedOS
                }
            });
            if (response.data.command) {
                setInstallCommand(response.data.command);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingCommand(false);
        }
    };

    const fetchLightweightCommand = async (agentId?: string) => {
        setLoadingCommand(true);

        try {
            const params: any = {
                client_id: level.id,
                platform: selectedOS
            };
            if (agentId) params.agent_id = agentId;

            const response = await baseapi.get('/agents/install/lightweight', {
                params
            });
            if (response.data.command) {
                setInstallCommand(response.data.command);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingCommand(false);
        }
    };

    useEffect(() => {
        if (selectedOS === 'windows' || selectedOS === 'darwin') {
            setIntsallAgentType('lightweight');
        }
    }, [selectedOS]);

    useEffect(() => {
        if (!showInstallModal) {
            setInstallCommand("");
            setSelectedProbeAgent(null);
            setCustomPort("");
            return;
        }

        if (install_agentType === 'master') {
            setSelectedProbeAgent(null);
            fetchMasterCommand();
        } else if (install_agentType === 'lightweight') {
            fetchLightweightCommand(selectedProbeAgent?.id);
        }
    }, [install_agentType, showInstallModal, selectedOS, selectedProbeAgent]);


    //sorting
    //sorting
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(() => {
        const stored = localStorage.getItem('organization_settings');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                if (parsed.defaultSortKey && parsed.defaultSortDir) {
                    return { key: parsed.defaultSortKey, direction: parsed.defaultSortDir };
                }
            } catch (e) {
                console.error("Failed to parse organization_settings for sortConfig", e);
            }
        }
        return null;
    });
    const isSortable = (key: string) => !['actions', 'tags'].includes(key);
    const [showSubnetModal, setShowSubnetModal] = useState(false);
    // const [showCredsModal, setShowCredsModal] = useState(false);

    const currentLevel = useClientLevel();
    // const isFirstSearch = useRef(true);

    const [settingsVersion, setSettingsVersion] = useState(0);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleSettingsChangeRef = useRef<() => void>();
    handleSettingsChangeRef.current = () => {
        setSettingsVersion(prev => prev + 1);

        const stored = localStorage.getItem('organization_settings');
        let newSortConfig = { key: 'hostname', direction: 'asc' as 'asc' | 'desc' };
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                if (parsed.defaultSortKey && parsed.defaultSortDir) {
                    newSortConfig = { key: parsed.defaultSortKey, direction: parsed.defaultSortDir };
                }
            } catch (e) {
                console.error("Failed to parse organization_settings", e);
            }
        }
        setSortConfig(prev => {
            if (prev?.key === newSortConfig.key && prev?.direction === newSortConfig.direction) {
                return prev;
            }
            return newSortConfig;
        });
    };

    useEffect(() => {
        const handleSettingsChange = () => {
            if (handleSettingsChangeRef.current) {
                handleSettingsChangeRef.current();
            }
        };
        window.addEventListener('organization-settings-changed', handleSettingsChange);
        return () => window.removeEventListener('organization-settings-changed', handleSettingsChange);
    }, []);


    // Column visibility state
    const [columnVisibility, setColumnVisibility] = useState<Record<ColumnKey, boolean>>({
        hostname: true,
        ip_address: true,
        mac_address: true,
        status: true,
        version: true,
        platform: true,
        architecture: true,
        tags: true,
        registered_at: true,
        last_seen: true,
        actions: true,
        agent_type: true,
        client_name: true,

    });

    const dropdownRef = useRef<HTMLDivElement>(null);

    //permissions
    const handleAssetNavigate = (path: string) => {
        if (!hasPermission('assets', 'read')) {
            showInfo("You don't have permission to access assets. Please contact the administrator.");
            return;
        }
        navigate(path);
    };

    const handleCredentialsNavigate = (path: string) => {
        if (!hasPermission('credentials', 'read')) {
            showInfo("You don't have permission to access credentials. Please contact the administrator.");
            return;
        }
        navigate(path);
        setOpenMenuId(null);
    };


    const fetchData = async (
        skip: number = (currentPage - 1) * itemsPerPage || 0, limit: number = itemsPerPage || 30,
        orderBy: Record<string, 'asc' | 'desc'>[] = [{ [sortConfig?.key || 'name']: sortConfig?.direction || 'desc' }]) => {
        try {
            setLoading(true)

            const [sortEntry] = orderBy;
            const sort_by = Object.keys(sortEntry)[0];
            const sort_order = sortEntry[sort_by];


            const queryObj: any = {
                ...(level?.id ? { client_id: level.id } : {}),
                ...(agentType !== 'all' ? { agent_type: agentType } : {})
            };

            if (debouncedSearch) {
                queryObj.$or = [
                    { hostname: { "$ilike": `%${debouncedSearch}%` } },
                    { ip_address: { "$ilike": `%${debouncedSearch}%` } },
                    { name: { "$ilike": `%${debouncedSearch}%` } },
                    { platform: { "$ilike": `%${debouncedSearch}%` } }
                ];
            }

            const params = {
                query: JSON.stringify(queryObj),

                skip: skip,
                limit: limit,
                sort_by: sort_by,
                sort_order: sort_order
            }

            try {
                const response = await baseapi.get('/agents', { params })
                // const response ={data:{status: false}}
                if (response.data.status) {
                    setAgentData(response.data.data)
                    setLoading(false)
                    setTotalPages(Math.ceil(response.data.total / limit))
                    setTotalItems(response.data.total)
                } else {
                    // Fallback to mock data
                    setAgentData([])
                    setTotalPages(0)
                    setTotalItems(0)
                    setLoading(false)
                }
            } catch (apiError) {
                console.warn('API call failed, using mock data:', apiError);
                // Use mock data as fallback
                setAgentData([])
                setTotalPages(0)
                setTotalItems(0)
                setLoading(false)
            }
        }
        catch (error: any) {
            showError(error.message)
            // Fallback to mock data
            setAgentData([])
            setTotalPages(0)
            setTotalItems(0)
            setLoading(false)
        }
    };

    // Debounce search term
    useEffect(() => {
        const handler = setTimeout(() => {
            if (debouncedSearch !== searchTerm) {
                setDebouncedSearch(searchTerm);
                setCurrentPage(1);
            }
        }, 500);
        return () => clearTimeout(handler);
    }, [searchTerm, debouncedSearch]);

    // Declarative data fetching effect
    useEffect(() => {
        fetchData(
            (currentPage - 1) * itemsPerPage,
            itemsPerPage,
            [{ [sortConfig?.key || 'hostname']: sortConfig?.direction || 'desc' }]
        );
    }, [currentPage, itemsPerPage, agentType, currentLevel, debouncedSearch, sortConfig, refreshTrigger]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowColumnSettings(false);
            }
            if (menuDropdownRef.current && !menuDropdownRef.current.contains(event.target as Node)) {
                setOpenMenuId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleRefresh = () => {
        setSearchTerm('');
        setDebouncedSearch('');
        setCurrentPage(1);
        setRefreshTrigger(prev => prev + 1);
    };

    // const filteredData = agentData.filter((item: any) =>
    //     item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item.hostname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item.ip_address?.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    const copyToClipboard = async (text: any, _fieldName: any) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    const handleRescanSubmit = async (data: any) => {
        try {
            const response = await baseapi.post('/agents/agent-task', data);
            if (response.data.status) {
                showSuccess(response.data.message);

                if (response.data.data?.download_url) {
                    const link = document.createElement('a');
                    link.href = response.data.data.download_url;
                    link.setAttribute('download', response.data.data.filename || 'download.zip');

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }

                // Optionally refresh the agent data
                setRefreshTrigger(prev => prev + 1);
            } else {
                showError(response.data.message);
            }
        } catch (error: any) {
            showError(error.message);
        }
    };


    const getStatusColor = (status: string) => {
        switch (status) {
            case 'online': return 'text-green-400';
            case 'offline': return 'text-red-500';
            case 'busy': return 'text-yellow-400';
            case 'error': return 'text-red-400';
            case 'maintenance': return 'text-blue-400';
            default: return 'text-gray-100';
        }
    };

    const getStatusBg = (status: string) => {
        switch (status) {
            case 'online': return 'bg-green-400';
            case 'offline': return 'bg-red-500';
            case 'busy': return 'bg-yellow-400';
            case 'error': return 'bg-red-400';
            case 'maintenance': return 'bg-blue-400';
            default: return 'bg-gray-400';
        }
    };


    const getPlatformIcon = (platform: string) => {
        switch (platform) {
            case 'windows': return '/windows.png';
            case 'linux': return '/linux.svg';
            case 'darwin': return '/mac.png';
            default: return null;
        }
    };

    const toggleColumn = (columnName: ColumnKey) => {
        setColumnVisibility(prev => ({
            ...prev,
            [columnName]: !prev[columnName]
        }));
    };

    const toggleAllColumns = () => {
        const allVisible = Object.values(columnVisibility).every(visible => visible);

        const newVisibility: Record<ColumnKey, boolean> = Object.keys(columnVisibility).reduce((acc, key) => {
            acc[key as ColumnKey] = !allVisible;
            return acc;
        }, {} as Record<ColumnKey, boolean>);

        setColumnVisibility(newVisibility);
    };

    const handleSort = (key: string) => {
        setSortConfig((prev) => {
            if (prev?.key === key) {
                const newDirection = prev.direction === 'asc' ? 'desc' : 'asc';
                return { key, direction: newDirection };
            } else {
                return { key, direction: 'asc' };
            }
        });
    };

    //pagination functions
    const handlePageChange = (page: number): void => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleItemsPerPageChange = (value: number): void => {
        setItemsPerPage(value);
        setCurrentPage(1);
    };



    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setDropdownPosition({
            top: rect.bottom + 1,
            left: rect.right - 160, // adjust for alignment
        });
        setOpenMenuId(openMenuId === id ? null : id);
    };





    // const handleDelete = async (agent_id: string) => {
    //     try {
    //         const response = await baseapi.delete(`/agents/${agent_id}`)
    //         if (response.data.status) {
    //             showSuccess(response.data.message)
    //             fetchData()
    //         }
    //         else {
    //             showError(response.data.message)
    //         }
    //     }
    //     catch (error: any) {
    //         showError(error.message)
    //     }
    // };

    // const handleAgentClick = (agentId: any, client_id: any) => {
    //     localStorage.setItem('ids', JSON.stringify({ 'agent_id': agentId, client_id: client_id, 'path': "/agents/results" }))
    //     navigate("/agents/dashboard")
    // }

    const handleCopy = async (text: string, type: 'install' | 'reinstall' | 'uninstall' | 'download'): Promise<void> => {
        try {
            await navigator.clipboard.writeText(text);

            // Show checkmark animation
            setCopiedStates(prev => ({ ...prev, [type]: true }));
            showSuccess(`${type === 'download' ? 'Download link' : type.charAt(0).toUpperCase() + type.slice(1) + ' command'} copied!`);

            // Reset after animation
            setTimeout(() => {
                setCopiedStates(prev => ({ ...prev, [type]: false }));
            }, 1500);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const currentDownloadConfig = useMemo(() => {
        if (install_agentType === 'master' && (selectedOS === 'linux' || selectedOS === 'arm')) {
            return {
                url: 'https://runners.ovulscanner.com/agents/arm/ovul-agent-linux',
                filename: 'ovul-agent-linux',
                label: selectedOS === 'arm' ? 'ARM (Master)' : 'Linux (Master)',
            };
        }
        return AGENT_DOWNLOAD_URLS[selectedOS];
    }, [install_agentType, selectedOS]);

    const handleDownloadAgent = async () => {
        const config = currentDownloadConfig;
        setDownloadingAgent(true);

        try {
            const response = await fetch(config.url);
            if (response.ok) {
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = config.filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                setDownloadingAgent(false);
                return;
            }
        } catch {
            // Direct fetch fallback if blocked by CORS
        }

        const link = document.createElement('a');
        link.href = config.url;
        link.download = config.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDownloadingAgent(false);
    };

    const baseColumns: {
        key: ColumnKey;
        label: string;
        icon: React.ElementType;
        color: string;
    }[] = useMemo(() => {
        const defaultCols = [
            { key: 'ip_address' as ColumnKey, label: 'IP Address', icon: Wifi, color: 'text-green-400' },
            { key: 'hostname' as ColumnKey, label: 'Hostname', icon: Server, color: 'text-blue-400' },
            { key: 'agent_type' as ColumnKey, label: 'Agent Type', icon: Bot, color: 'text-indigo-400' },
            { key: 'platform' as ColumnKey, label: 'Platform', icon: Server, color: 'text-indigo-400' },
            { key: 'version' as ColumnKey, label: 'Version', icon: Info, color: 'text-cyan-400' },
            { key: 'architecture' as ColumnKey, label: 'Architecture', icon: Info, color: 'text-pink-400' },
            { key: 'status' as ColumnKey, label: 'Status', icon: AlertTriangle, color: 'text-yellow-400' },
            { key: 'client_name' as ColumnKey, label: 'Client Name', icon: User, color: 'text-gray-400 dark:text-gray-100' },
            { key: 'last_seen' as ColumnKey, label: 'Updated', icon: CalendarDays, color: 'text-gray-400 dark:text-gray-100' },
            { key: 'registered_at' as ColumnKey, label: 'Registered At', icon: Calendar, color: 'text-gray-400 dark:text-gray-100' },
            { key: 'actions' as ColumnKey, label: 'Action', icon: TableOfContents, color: 'text-gray-400 dark:text-gray-100' },
        ];

        const stored = localStorage.getItem('organization_settings');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                if (parsed.columnOrder && Array.isArray(parsed.columnOrder)) {
                    const ordered: typeof defaultCols = [];
                    parsed.columnOrder.forEach((k: string) => {
                        const found = defaultCols.find(c => c.key === k);
                        if (found) ordered.push(found);
                    });
                    defaultCols.forEach(c => {
                        if (!ordered.some(o => o.key === c.key)) {
                            ordered.push(c);
                        }
                    });

                    // Ensure 'registered_at' is right before 'actions', and 'actions' is the last column
                    const regIdx = ordered.findIndex(o => o.key === 'registered_at');
                    if (regIdx !== -1) {
                        const [regCol] = ordered.splice(regIdx, 1);
                        ordered.push(regCol);
                    }
                    const actionsIdx = ordered.findIndex(o => o.key === 'actions');
                    if (actionsIdx !== -1) {
                        const [actionsCol] = ordered.splice(actionsIdx, 1);
                        ordered.push(actionsCol);
                    }

                    return ordered;
                }
            } catch (e) {
                console.error("Failed to parse organization_settings for column ordering", e);
            }
        }
        return defaultCols;
    }, [settingsVersion]);

    const columns = useMemo(() => {
        return baseColumns.filter((col) => {
            // hide actions if no permission
            if (col.key === "actions" && !(canDelete || canEdit)) return false;

            // hide client_name if not global level
            if (col.key === "client_name" && level.name !== "global") return false;

            return true;
        });
    }, [baseColumns, level.name, canDelete, canEdit]);

    const renderCell = (key: ColumnKey, item: any) => {
        switch (key) {
            case 'ip_address':
                return (
                    <td key={key} className="px-1 py-0.5 font-mono text-center">
                        <div className="flex items-center justify-center gap-2 group/copy">
                            <button
                                onClick={() => handleAssetNavigate(`/asset?agent_id=${item.id}`)}
                                className="text-blue-500 text-[11px] font-bold leading-none cursor-pointer">
                                {item.ip_address || '-'}
                            </button>
                            {item.ip_address && (
                                <button
                                    onClick={() => copyToClipboard(item.ip_address, `ip-${item.id}`)}
                                    className="opacity-0 group-hover/copy:opacity-100 transition-opacity"
                                    title="Copy IP address"
                                >
                                    <Copy className="w-2.5 h-2.5 text-gray-500 dark:text-gray-100 hover:text-gray-700 dark:hover:text-white" />
                                </button>
                            )}
                        </div>
                    </td>
                );
            case 'hostname':
                return (
                    <td key={key} className="px-1 py-0.5 font-mono text-center">
                        <div className="flex items-center justify-center gap-2 group/copy">
                            <span className="text-gray-800 dark:text-gray-100 text-[10px] leading-none truncate max-w-[200px]" title={item.hostname || '-'}>
                                {item.hostname || '-'}
                            </span>
                            {item.hostname && (
                                <button
                                    onClick={() => copyToClipboard(item.hostname, `hostname-${item.id}`)}
                                    className="opacity-0 group-hover/copy:opacity-100 transition-opacity"
                                    title="Copy hostname"
                                >
                                    <Copy className="w-2.5 h-2.5 text-gray-500 dark:text-gray-100 hover:text-gray-700 dark:hover:text-white" />
                                </button>
                            )}
                        </div>
                    </td>
                );
            case 'agent_type':
                return (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <div className="flex items-center justify-center gap-2">
                            <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium capitalize">
                                {item.agent_type === 'lightweight' ? 'End Point agent' : (item.agent_type || '-')}
                            </span>
                        </div>
                    </td>
                );
            case 'platform':
                return (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <div className="flex items-center justify-center gap-2">
                            {getPlatformIcon(item.platform) && (
                                <img src={getPlatformIcon(item.platform) || ''} alt={item.platform} className="w-4 h-4.5" />
                            )}
                            <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium capitalize">
                                {item.platform || '-'}
                            </span>
                        </div>
                    </td>
                );
            case 'version':
                return (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <span className="text-[10px] text-gray-800 dark:text-gray-100 font-mono">
                            {item.version || '-'}
                        </span>
                    </td>
                );
            case 'architecture':
                return (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium">
                            {item.architecture || '-'}
                        </span>
                    </td>
                );
            case 'status':
                return (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <div
                            className="inline-flex items-center gap-2 px-2.5 py-0.5 rounded-full border border-gray-200 dark:border-gray-700/50 bg-gray-100 dark:bg-gray-900/50 relative group transition-colors duration-200"
                        >
                            {/* Status Dot */}
                            <div className={`w-1.5 h-1.5 rounded-full ${getStatusBg(item.status)}`}></div>

                            {/* Status Text */}
                            <span
                                className={`text-[9px] font-bold uppercase tracking-wide ${getStatusColor(item.status)}`}
                            >
                                {item.status}
                            </span>

                            {/* Tooltip (only if last_pinged_time exists) */}
                            {item.last_pinged_time && (
                                <div className="absolute bottom-full left-0 mb-1 hidden group-hover:block bg-gray-900 text-white text-[9px] rounded px-2 py-1 whitespace-nowrap z-10 shadow-lg">
                                    <div>Last pinged</div>
                                    <div>{new Date(item.last_pinged_time).toLocaleString()}</div>
                                </div>
                            )}
                        </div>
                    </td>
                );
            case 'client_name':
                return (level.name === 'global') ? (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium">
                            {item?.client_name}
                        </span>
                    </td>
                ) : null;
            case 'registered_at': {
                const regDateStr = item?.registered_at ? String(item.registered_at) : '';
                const regDateObj = regDateStr
                    ? new Date(regDateStr.endsWith('Z') || regDateStr.includes('+') ? regDateStr : `${regDateStr}Z`)
                    : null;
                const validRegDate = regDateObj && !isNaN(regDateObj.getTime()) ? regDateObj : (regDateStr ? new Date(regDateStr) : null);

                return (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium whitespace-nowrap">
                            {validRegDate && !isNaN(validRegDate.getTime())
                                ? validRegDate.toLocaleString(undefined, {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    year: "numeric",
                                    month: "short",
                                    day: "2-digit",
                                    hour12: true,
                                })
                                : "-"}
                        </span>
                    </td>
                );
            }
            case 'last_seen':
                return (
                    <td key={key} className="px-1 py-0.5 text-center">
                        <span className="text-[10px] text-gray-800 dark:text-gray-100 font-medium">
                            {item?.last_seen
                                ? new Date(item.last_seen).toLocaleString(undefined, {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    year: "numeric",
                                    month: "short",
                                    day: "2-digit",
                                    hour12: true,
                                })
                                : "-"}
                        </span>
                    </td>
                );
            case 'actions':
                return (canDelete || canEdit) ? (
                    <td key={key} className="px-1 py-0.5 whitespace-nowrap text-center text-xs font-medium sticky right-0 z-10 bg-white dark:bg-gray-900 group-hover:bg-gray-50 dark:group-hover:bg-gray-800 transition-colors duration-200">
                        <div className="flex items-center justify-center space-x-2 relative">
                            <div className="relative">
                                <button
                                    onClick={(e) => handleMenuOpen(e, item.id)} // ✅ Correct call
                                    className="text-gray-600 dark:text-white p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors flex items-center cursor-pointer"
                                >
                                    <CircleEllipsis className="w-4 h-4" />
                                </button>

                                {openMenuId === item.id &&
                                    createPortal(
                                        <div
                                            ref={menuDropdownRef} // ✅ this enables outside click detection
                                            className="mt-2 w-40 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-[9999] py-1"
                                            style={{
                                                top: dropdownPosition.top,
                                                left: dropdownPosition.left,
                                                position: "fixed",
                                            }}
                                        >
                                            {(item.agent_type || agentType) === "lightweight" ? (
                                                <>
                                                    {canEdit && (
                                                        <button
                                                            onClick={() => {
                                                                setSelectedAgent(item);
                                                                if (item.is_ad_server) {
                                                                    setModalJobTypes([
                                                                        { value: 'local_asset_scan', label: 'Lightweight Scan' },
                                                                        { value: 'ad_scan', label: 'AD Scan' }
                                                                    ]);
                                                                } else {
                                                                    setModalJobTypes([
                                                                        { value: 'local_asset_scan', label: 'Lightweight Scan' }
                                                                    ]);
                                                                }
                                                                setShowRescanModal(true);
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <ScanSearch className="w-4 h-4 text-emerald-500 dark:text-emerald-400" />
                                                            Scan
                                                        </button>)}
                                                    {canDelete && (
                                                        <button
                                                            onClick={() => {
                                                                setUnistallModalOpen(true);
                                                                setUninstallAgent(item);
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <Trash className="w-4 h-4 text-red-500 dark:text-red-400" />
                                                            Uninstall
                                                        </button>)}
                                                    {canEdit && (
                                                        <button
                                                            onClick={() => {
                                                                handleRescanSubmit({
                                                                    agent_id: item.id,
                                                                    job_type: "update_agent",
                                                                    parameters: {},
                                                                });
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <ArrowBigUp className="w-4 h-4 text-orange-500 dark:text-orange-400" />
                                                            Update
                                                        </button>)}
                                                    {canEdit && (
                                                        <button
                                                            onClick={() => {
                                                                handleRescanSubmit({
                                                                    client_id: item.client_id,
                                                                    agent_id: item.id,
                                                                    job_type: "pull_logs",
                                                                    parameters: {},
                                                                });
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <Download className="w-4 h-4 text-orange-500 dark:text-orange-400" />
                                                            Pull Logs
                                                        </button>)}
                                                    {canEdit && (
                                                        <button
                                                            onClick={() => {
                                                                handleRescanSubmit({
                                                                    client_id: item.client_id,
                                                                    agent_id: item.id,
                                                                    job_type: "download_logs",
                                                                    parameters: {},
                                                                });
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <DownloadCloud className="w-4 h-4 text-orange-500 dark:text-orange-400" />
                                                            Download Logs
                                                        </button>)}
                                                </>
                                            ) : (
                                                <>
                                                    {canEdit && (
                                                        <button
                                                            onClick={() => {
                                                                setSelectedAgent(item);
                                                                setModalJobTypes(undefined);
                                                                setShowRescanModal(true);
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <ScanSearch className="w-4 h-4 text-emerald-500 dark:text-emerald-400" />
                                                            Scan
                                                        </button>)}

                                                    {canDelete && (
                                                        <button
                                                            onClick={() => {
                                                                setUnistallModalOpen(true);
                                                                setUninstallAgent(item);
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <Trash className="w-4 h-4 text-red-500 dark:text-red-400" />
                                                            Delete
                                                        </button>)}

                                                    <button
                                                        onClick={() => {
                                                            handleCredentialsNavigate(`/agent-credentials/${item.id}?client_id=${item.client_id}`);
                                                        }}
                                                        className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors cursor-pointer"
                                                    >
                                                        <Key className="w-4 h-4 text-blue-500 dark:text-blue-400" />
                                                        Credentials Config
                                                    </button>

                                                    {item.agent_type === 'probe' && (
                                                        <button
                                                            onClick={() => {
                                                                navigate(`/agent-ssh/${item.id}`, { state: { ip: item.ip_address, clientId: item.client_id } });
                                                                setOpenMenuId(null);
                                                            }}
                                                            className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center gap-2 transition-colors"
                                                        >
                                                            <Terminal className="w-4 h-4 text-orange-500 dark:text-orange-400" />
                                                            SSH
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </div>,
                                        document.body
                                    )}
                            </div>
                        </div>
                    </td>
                ) : null;
            default:
                return null;
        }
    };

    return (
        <div className="text-gray-800 dark:text-gray-100 p-3 pb-20 min-h-screen transition-colors duration-200">
            <div className="w-full mx-auto">
                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-2">
                    <div className="flex items-center gap-1.5">
                        <div className="bg-orange-600 p-1.5 rounded shadow-lg">
                            <Bot className="w-4 h-4 text-white" />
                        </div>
                        <div>
                            <h1 className="font-bold text-lg text-gray-900 dark:text-gray-200 leading-none transition-colors duration-200">Agents</h1>
                        </div>
                        {!loading &&
                            <div className='font-bold text-lg text-gray-500 dark:text-gray-100 transition-colors duration-200'>
                                ({totalItems})
                            </div>
                        }

                    </div>

                    {/* Search and Controls */}
                    <div className="flex items-center gap-2">
                        {/* Column Settings */}
                        <button
                            onClick={handleRefresh}
                            disabled={loading}
                            className="rounded-lg bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-100 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-sm"
                        >
                            <RefreshCw className={`w-3.5 h-3.5 ${loading ? 'animate-spin' : ''}`} />
                        </button>

                        <div className="relative w-full sm:w-56">
                            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-100 w-3.5 h-3.5 transition-colors duration-200" />
                            <input
                                type="text"
                                placeholder="Search agents..."
                                className="w-full bg-white dark:bg-gray-800/50 border border-gray-300 dark:border-gray-700 rounded-lg pl-8 pr-3 py-1.5 text-[11px] text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:border-orange-500 outline-none transition-colors duration-200 shadow-sm"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>

                        <div className="relative" ref={dropdownRef} data-col-menu>
                            <button
                                onClick={() => setShowColumnSettings(!showColumnSettings)}
                                className="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-100 transition-colors duration-200 flex items-center gap-2 shadow-sm"
                            >
                                <Columns3 className="w-3.5 h-3.5" />
                                <span className="text-[10px] font-bold uppercase tracking-wider">Columns</span>
                            </button>

                            {/* Dropdown */}
                            {showColumnSettings && (
                                <div className="absolute top-full mt-2 right-0 w-52 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl z-[110] p-1.5 max-h-[450px] overflow-y-auto transition-colors duration-200">
                                    <div className="px-3 py-1.5 text-[9px] font-bold text-gray-700 dark:text-gray-100 uppercase border-b border-gray-200 dark:border-gray-800 mb-1 flex items-center justify-between transition-colors duration-200">
                                        <span>Toggle Columns</span>
                                        <button
                                            onClick={toggleAllColumns}
                                            className="text-[9px] text-orange-600 dark:text-orange-400 hover:text-orange-500 dark:hover:text-orange-300 transition-colors duration-200"
                                        >
                                            {Object.values(columnVisibility).every(Boolean)
                                                ? 'Hide All'
                                                : 'Show All'}
                                        </button>
                                    </div>
                                    {columns.map(({ key, label, icon: Icon, color }) => (
                                        <button
                                            key={key}
                                            onClick={() => toggleColumn(key)}
                                            className="w-full flex items-center justify-between px-3 py-2 text-[10px] font-bold uppercase text-gray-700 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors duration-200"
                                        >
                                            <div className="flex items-center gap-2.5">
                                                <Icon className={`w-3 h-3 ${columnVisibility[key] ? color : 'text-gray-600 dark:text-gray-600'}`} />
                                                {label}
                                            </div>
                                            <div className={`w-3 h-3 rounded border flex items-center justify-center transition-colors duration-200 ${columnVisibility[key] ? 'bg-orange-600 border-orange-600' : 'border-gray-300 dark:border-gray-700'}`}>
                                                {columnVisibility[key] && <Check className="w-2.5 h-2.5 text-white" />}
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>


                        {level.name !== 'global' && canCreate && (
                            <button
                                onClick={() => setShowInstallModal(true)}
                                className="flex items-center gap-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-1.5 text-[11px] text-gray-800 dark:text-white font-bold hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-sm"
                            >
                                <Download className="w-4 h-4 text-orange-500" />
                                Install
                            </button>
                        )}

                        <button
                            onClick={() => setShowExportModal(true)}
                            className="flex items-center gap-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg px-4 py-1.5 text-[11px] text-gray-800 dark:text-white font-bold hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 shadow-sm"
                        >
                            <Download className="w-4 h-4 text-cyan-500" />
                            Export
                        </button>

                        <CustomDropdown
                            data={agent_type_vals}
                            width="w-42"
                            placeholder="All Status"
                            selectedValue={agentType}
                            onSelect={setAgentType}
                            className="transition-colors duration-200"
                            buttonHeight={8}
                        />
                    </div>
                </div>


                {/* Table */}
                <div className="bg-white dark:bg-gray-800/40 border border-gray-200 dark:border-gray-700 rounded-t-xl overflow-hidden shadow-sm dark:shadow-2xl transition-colors duration-200">
                    <ScrollContainer
                        className="overflow-x-auto custom-scroll cursor-grab active:cursor-grabbing"
                        horizontal={true}
                        vertical={false}
                        hideScrollbars={false}
                    >
                        <table className="w-full text-left text-xs border-collapse">
                            <thead className="bg-gray-50 dark:bg-gray-800/80 sticky top-0 z-10 transition-colors duration-200">
                                <tr className="border-b border-gray-200 dark:border-gray-700/50 transition-colors duration-200">
                                    {columns.map(({ key, label }) =>
                                        columnVisibility[key] ? (
                                            <th
                                                key={key}
                                                onClick={() => key !== 'actions' && key !== 'tags' && handleSort(key)}
                                                className={`px-1 py-1.5 text-[10px] font-bold text-gray-700 dark:text-gray-100 uppercase tracking-widest select-none whitespace-nowrap transition-colors duration-200 ${key === 'actions' ? 'text-left sticky right-0 bg-gray-50 dark:bg-gray-800 z-10' : 'text-center cursor-pointer'
                                                    }`}
                                            >
                                                <div className={`flex items-center gap-1.5 justify-center`}>
                                                    {label}
                                                    {isSortable(key) && (
                                                        sortConfig?.key === key ? (
                                                            sortConfig.direction === 'asc' ? (
                                                                <ChevronUp size={12} />
                                                            ) : (
                                                                <ChevronDown size={12} />
                                                            )
                                                        ) : (
                                                            <ChevronDown size={12} />
                                                        )
                                                    )}
                                                </div>
                                            </th>
                                        ) : null
                                    )}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 dark:divide-gray-700/30 transition-colors duration-200">
                                {agentData.length === 0 && !loading ? (
                                    <tr>
                                        <td colSpan={Object.values(columnVisibility).filter(Boolean).length} className="py-16 text-center text-gray-500 dark:text-gray-100 font-bold uppercase tracking-widest italic transition-colors duration-200">
                                            No agents found
                                        </td>
                                    </tr>
                                ) : loading ? (
                                    <tr>
                                        <td colSpan={Object.values(columnVisibility).filter(Boolean).length} className="py-16 text-center text-gray-700 dark:text-gray-200 font-bold uppercase tracking-widest italic transition-colors duration-200">
                                            <div className="flex items-center justify-center gap-2">
                                                <Loader2 className="w-4 h-4 animate-spin text-orange-500" />
                                                Loading agents
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    agentData.map((item: any, _index: any) => (
                                        <tr
                                            key={item.id}
                                            className="hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-colors duration-200 group border-b border-gray-100 dark:border-gray-700/30"
                                        >
                                            {columns.map(({ key }) =>
                                                columnVisibility[key] ? renderCell(key, item) : null
                                            )}

                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </ScrollContainer>
                </div>


                {/* Table Footer */}
                <div className="bg-gray-50 dark:bg-gray-800/50 border rounded-b-xl border-gray-200 dark:border-gray-700 px-2 py-1 flex items-center justify-between transition-colors duration-200">
                    <div className="flex items-center gap-4">
                        <ItemsPerPageDropdown
                            value={itemsPerPage}
                            onChange={(val: any) => handleItemsPerPageChange(val)}
                        />
                        <span className="text-[10px] text-gray-600 dark:text-gray-100 font-bold uppercase tracking-widest transition-colors duration-200">
                            <span className="text-gray-900 dark:text-gray-200">{startIndex + 1}</span> - <span className="text-gray-900 dark:text-gray-200">{Math.min(endIndex, totalItems)}</span> OF {totalItems}
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="p-1.5 text-gray-600 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white disabled:opacity-30 transition-colors duration-200"><ChevronsLeft className="w-4 h-4" /></button>
                        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="p-1.5 text-gray-600 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white disabled:opacity-30 transition-colors duration-200"><ChevronLeft className="w-4 h-4" /></button>
                        <div className="px-3 py-1 bg-orange-600 rounded-lg text-white text-[11px] font-bold mx-1.5 shadow-lg shadow-orange-900/20">{currentPage}</div>
                        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-1.5 text-gray-600 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white disabled:opacity-30 transition-colors duration-200"><ChevronRight className="w-4 h-4" /></button>
                        <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="p-1.5 text-gray-600 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white disabled:opacity-30 transition-colors duration-200"><ChevronsRight className="w-4 h-4" /></button>
                    </div>
                </div>
            </div>

            <Modal open={showInstallModal} onClose={() => setShowInstallModal(false)}>
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
        w-[90%] sm:w-[520px] max-w-lg max-h-[90vh] overflow-y-auto bg-white dark:bg-gray-900/95 backdrop-blur-xl 
        border border-gray-200 dark:border-blue-400/20 shadow-2xl p-4 rounded-xl text-gray-900 dark:text-white
        relative">

                    {/* Subtle top border */}
                    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-400/40 to-transparent"></div>

                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center">
                            <Download className='h-6 w-6 text-blue-500 dark:text-blue-400 mr-2' />
                            <h2 className="text-xl font-bold text-gray-900 dark:text-white">Install Agent</h2>
                        </div>
                        <button
                            onClick={() => setShowInstallModal(false)}
                            className="text-gray-400 hover:text-gray-600 dark:text-gray-100 dark:hover:text-white transition-colors"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>

                    {/* OS Selection Tabs */}
                    <div className="flex mb-4 bg-gray-100 dark:bg-white/10 backdrop-blur-md rounded-lg p-1 border border-gray-200 dark:border-white/20">
                        <button
                            onClick={() => setSelectedOS('windows')}
                            disabled={install_agentType === 'master'}
                            className={`flex-1 mr-2 flex items-center justify-center gap-2 py-1 px-4 rounded-md transition-all ${install_agentType === 'master' ? 'opacity-30 cursor-not-allowed grayscale' : ''} ${selectedOS === 'windows'
                                ? 'bg-purple-100 dark:bg-purple-400/20 backdrop-blur-sm border border-purple-300 dark:border-purple-400/50 text-purple-900 dark:text-white shadow-sm dark:shadow-lg'
                                : 'text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white'
                                }`}
                        >
                            <img src="/windows.png" alt="Windows" className="w-6 h-6" />
                            Windows
                        </button>
                        <button
                            onClick={() => setSelectedOS('linux')}
                            className={`flex-1 flex items-center justify-center gap-2 py-1 px-4 rounded-md transition-all  ${selectedOS === 'linux'
                                ? 'bg-purple-100 dark:bg-purple-400/20 backdrop-blur-sm border border-purple-300 dark:border-purple-400/50 text-purple-900 dark:text-white shadow-sm dark:shadow-lg'
                                : 'text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white'
                                }`}
                        >
                            <img src="/linux.svg" alt="Linux" className="w-6 h-6" />
                            Linux
                        </button>
                        <button
                            onClick={() => setSelectedOS('darwin')}
                            disabled={install_agentType === 'master'}
                            className={`flex-1 flex items-center justify-center gap-2 py-1 px-4 rounded-md transition-all ${install_agentType === 'master' ? 'opacity-30 cursor-not-allowed grayscale' : ''} ${selectedOS === 'darwin'
                                ? 'bg-purple-100 dark:bg-purple-400/20 backdrop-blur-sm border border-purple-300 dark:border-purple-400/50 text-purple-900 dark:text-white shadow-sm dark:shadow-lg'
                                : 'text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white'
                                }`}
                        >
                            <img src="/mac.png" alt="Darwin" className="w-6 h-6.5" />
                            Mac
                        </button>
                        <button
                            onClick={() => setSelectedOS('arm')}
                            className={`flex-1 flex items-center justify-center gap-2 py-1 px-4 rounded-md transition-all  ${selectedOS === 'arm'
                                ? 'bg-purple-100 dark:bg-purple-400/20 backdrop-blur-sm border border-purple-300 dark:border-purple-400/50 text-purple-900 dark:text-white shadow-sm dark:shadow-lg'
                                : 'text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white'
                                }`}
                        >
                            <img src="/raspberrypi.svg" alt="Arm" className="w-6 h-6" />
                            Arm
                        </button>
                    </div>

                    <div className='flex gap-2 mb-3'>
                        <div className='w-full'>
                            <div className='flex text-violet-600 dark:text-violet-500 items-center gap-1 mb-1'>
                                <Bot className='w-4 h-4' />
                                <span className='text-sm font-medium'>Agent Type</span>
                            </div>
                            <CustomDropdown
                                data={(selectedOS === 'windows' || selectedOS === 'darwin') ? [install_agentType_vals[0]] : install_agentType_vals}
                                width="w-32"
                                placeholder="All Status"
                                selectedValue={install_agentType}
                                onSelect={setIntsallAgentType} // Direct state setter!
                                disabled={selectedOS === 'windows' || selectedOS === 'darwin'}
                                className="w-full transition-all duration-300"
                                buttonHeight={11}
                            />
                        </div>


                        {install_agentType === 'lightweight' && (
                            <div className='w-full'>
                                <div className='flex items-center gap-1 mb-1 text-sky-600 dark:text-sky-500'>
                                    <Server className='w-4 h-4' />
                                    <span className='text-sm font-medium'>Select Agent</span>
                                </div>
                                <SingleSelectApiDropdown
                                    apiEndpoint="/agents"
                                    displayProperty="hostname"
                                    secondaryDisplayProperty="ip_address"
                                    searchFields={['hostname', 'ip_address']}
                                    value={selectedProbeAgent}
                                    onChange={setSelectedProbeAgent}
                                    additionalQueries={{
                                        agent_type: 'probe',
                                        client_id: level.id
                                    }}
                                    placeholder="Select a probe agent"
                                    searchInputPlaceholder="Search by hostname or IP"
                                    className="w-full"
                                />
                            </div>
                        )}
                    </div>

                    {/* Command Sections */}
                    <div className="space-y-4">
                        {/* Download Agent Section */}
                        <div className="flex items-center justify-between p-2 rounded-lg bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700">
                            <div className="flex items-center gap-1.5 min-w-0">
                                <Download className="w-4 h-4 text-blue-500 shrink-0" />
                                <span className="text-xs font-medium text-gray-700 dark:text-gray-300">Agent:</span>
                                <span className="text-xs font-mono text-blue-600 dark:text-blue-400 truncate">{currentDownloadConfig.filename}</span>
                            </div>
                            <div className="flex items-center gap-2 shrink-0">
                                <CopyButton
                                    onClick={() => handleCopy(currentDownloadConfig.url, 'download')}
                                    copied={copiedStates.download}
                                >
                                    Copy Link
                                </CopyButton>
                                <button
                                    type="button"
                                    onClick={handleDownloadAgent}
                                    disabled={downloadingAgent}
                                    className="flex items-center gap-1 px-2.5 py-1 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white rounded text-xs font-medium transition-colors disabled:opacity-50 cursor-pointer shadow-xs"
                                >
                                    {downloadingAgent ? (
                                        <>
                                            <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                            <span>Downloading</span>
                                        </>
                                    ) : (
                                        <>
                                            <Download className="w-3.5 h-3.5" />
                                            <span>Download</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                        {/* Install Command */}
                        <div>
                            <div className="flex items-center justify-between mb-2">

                                <span className="text-sm font-medium text-green-600 dark:text-green-400 flex items-center">
                                    <CirclePlus className="w-4 h-4 mr-1" />
                                    Install
                                </span>

                                <CopyButton
                                    onClick={() => {
                                        if (installCommand) {
                                            handleCopy(installCommand + (customPort ? ` --port ${customPort}` : ''), 'install');
                                        }
                                    }}
                                    copied={copiedStates.install}
                                >
                                    Copy
                                </CopyButton>
                            </div>

                            {install_agentType === 'master' && (
                                <div className='text-xs text-orange-600 dark:text-orange-400 mb-2'>
                                    *Master agent will be on the port 9847
                                </div>
                            )}



                            {installCommand && (
                                <code className="text-green-700 dark:text-green-400 font-mono text-xs block bg-gray-50 dark:bg-gray-800/50 p-2 rounded border border-gray-200 dark:border-gray-700 break-all">
                                    {loadingCommand ? "Loading command..." : `${installCommand}${customPort ? ` --port ${customPort}` : ''}`}
                                </code>
                            )}
                            {install_agentType === 'master' && (
                                <div className="mt-2">
                                    <input
                                        type="number"
                                        placeholder="Enter Port (Optional)"
                                        className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded p-2 text-[11px] text-gray-900 dark:text-white focus:border-blue-500 outline-none"
                                        value={customPort}
                                        onChange={(e) => setCustomPort(e.target.value)}
                                    />
                                </div>
                            )}
                        </div>


                        {/* Uninstall Command */}
                        <div>
                            <div className="flex items-center justify-between mb-2">
                                <span className="text-sm font-medium text-red-600 dark:text-red-400 flex items-center">
                                    <Trash2 className="w-4 h-4 mr-1" />
                                    Uninstall
                                </span>
                                <CopyButton
                                    onClick={() => {
                                        const uninstallCmd = selectedOS === 'windows' ? './ovulscanner.exe -u' : selectedOS === 'darwin' ? './ovulscanner_darwin -u' : './ovulscanner_linux -u';
                                        handleCopy(uninstallCmd, 'uninstall');
                                    }}
                                    copied={copiedStates.uninstall}
                                >
                                    Copy
                                </CopyButton>
                            </div>
                            <code className="text-red-700 dark:text-red-400 font-mono text-xs block bg-gray-50 dark:bg-gray-800/50 p-2 rounded border border-gray-200 dark:border-gray-700">
                                {selectedOS === 'windows' ? './ovulscanner.exe -u' : selectedOS === 'darwin' ? './ovulscanner_darwin -u' : './ovulscanner_linux -u'}
                            </code>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="flex justify-end mt-4">
                        <button
                            onClick={() => setShowInstallModal(false)}
                            className="px-4 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-white rounded-lg text-sm font-medium transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal open={unistallModalOpen} onClose={() => setUnistallModalOpen(false)}>
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
              w-[95%] sm:w-[500px] md:w-[550px] max-w-2xl bg-white dark:bg-gray-900/95 backdrop-blur-xl 
              border border-gray-200 dark:border-red-400/20 shadow-2xl p-4 rounded-2xl text-gray-900 dark:text-white
              relative overflow-hidden">

                    {/* Subtle top border */}
                    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-400/40 to-transparent"></div>

                    {/* Header */}
                    <div className="flex items-center mb-4">
                        <div className="flex items-center justify-center mr-2 text-red-500 dark:text-red-400">
                            <Trash2 className='h-7 w-7' />
                        </div>
                        <div className='flex items-center justify-center'>
                            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Confirm Uninstall</h2>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="mb-4 bg-gray-50 dark:bg-gray-800/30 p-3 rounded-lg border border-gray-200 dark:border-gray-700/50 space-y-3">
                        <p className="text-gray-800 dark:text-white/90 text-lg">
                            Are you sure you want to uninstall the Agent <span className="font-semibold text-orange-500 dark:text-orange-400">{uninstallAgent?.name}</span>?
                        </p>
                        <div className='flex gap-2'>
                            <AlertTriangle className='text-red-500 dark:text-red-400 w-5 h-5' />
                            <p className="text-red-600 dark:text-red-400 text-sm font-medium">
                                Caution: All assets and data associated with this agent will be permanently removed from the system.
                            </p>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-4 justify-end">
                        <button
                            onClick={() => setUnistallModalOpen(false)}
                            className="px-6 py-3 border border-gray-300 dark:border-gray-600/50 text-gray-700 dark:text-gray-100 rounded-lg
              hover:border-gray-400 dark:hover:border-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800/50 hover:text-gray-900 dark:hover:text-white
              transition-all duration-200 font-medium min-w-[100px]"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                handleRescanSubmit({
                                    agent_id: uninstallAgent?.id,
                                    job_type: 'uninstall_agent',
                                    parameters: {}, // Empty parameters object
                                    client_id: uninstallAgent?.client_id
                                });
                                setUnistallModalOpen(false);
                            }}
                            className="px-6 py-3 bg-orange-500 text-white rounded-lg font-semibold
              hover:bg-orange-600 hover:shadow-lg hover:shadow-orange-500/20
              transition-all duration-200 min-w-[100px]"
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </Modal>

            <SubnetModal
                agent={selectedAgent}
                open={showSubnetModal}
                onClose={() => setShowSubnetModal(false)}
            />

            <AgentExportModal
                isOpen={showExportModal}
                onClose={() => setShowExportModal(false)}
                templateName="agents"
                clientId={level?.id}
            />

            {/* Rescan Modal */}
            <RescanModal
                open={showRescanModal}
                onClose={() => setShowRescanModal(false)}
                onSubmit={handleRescanSubmit}
                agent={selectedAgent}
                customJobTypes={modalJobTypes}
            />



        </div>
    );
};

export default AgentsTable;
